package one.healthium.reminders.di

import one.healthium.reminders.ui.RemindersViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val remindersUiModule = module {
    includes(remindersDataModule)
    viewModelOf(::RemindersViewModel)
}